<div [class.rtl]="currLang == 'ar'" class="modal" id="editCard" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <span class="modal-title">
                    {{'user-management.edit-requests.edit-modal.title'| translate}}
                </span>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form  [formGroup]="editRequestForm">
                    <div class="img-section">
                        <div class="avatar-picker" (click)="changeStudentProfile()">
                            <img *ngIf="image" class="avatar-picker__image" src="{{image}}">
                            <svg *ngIf="!image" class="avatar-picker__placeholder" id="student"
                                xmlns="http://www.w3.org/2000/svg" width="39.5" height="45.408"
                                viewBox="0 0 39.5 45.408">
                                <path id="Path_1481" data-name="Path 1481"
                                    d="M41.4,36.893V30H19v6.893a11.2,11.2,0,0,0,22.4,0Z"
                                    transform="translate(-10.452 -9.731)" fill="#707070" />
                                <path id="Path_1482" data-name="Path 1482"
                                    d="M26,51.74v3.783l5.17.741,5.17-.741V51.74A12.853,12.853,0,0,1,26,51.74Z"
                                    transform="translate(-11.42 -13.449)" fill="#707070" />
                                <path id="Path_1483" data-name="Path 1483" d="M47,35.17A2.585,2.585,0,1,0,47,30Z"
                                    transform="translate(-14.325 -9.115)" fill="#707070" />
                                <path id="Path_1484" data-name="Path 1484"
                                    d="M10.6,12.553l18.44,6.911,18.44-6.911L29.04,4.1Z"
                                    transform="translate(-9.29 -4.1)" fill="#707070" />
                                <path id="Path_1485" data-name="Path 1485"
                                    d="M43.478,55H35.723v1.723a.862.862,0,0,1-.741.853l-6.032.862a.849.849,0,0,1-.241,0l-6.032-.862a.862.862,0,0,1-.741-.853V55H14.181a5.185,5.185,0,0,0-5.1,4.308h39.5A5.185,5.185,0,0,0,43.478,55Z"
                                    transform="translate(-9.08 -13.9)" fill="#707070" />
                                <path id="Path_1486" data-name="Path 1486"
                                    d="M30.064,23.284a.888.888,0,0,1-.3-.052L18,18.82v7.91H42.127V18.82L30.365,23.232a.888.888,0,0,1-.3.052Z"
                                    transform="translate(-10.314 -7.006)" fill="#707070" />
                                <path id="Path_1487" data-name="Path 1487"
                                    d="M16.585,35.17V30a2.585,2.585,0,0,0,0,5.17Z" transform="translate(-9.761 -9.115)"
                                    fill="#707070" />
                            </svg>
                            <svg class="avatar-picker__camera" xmlns="http://www.w3.org/2000/svg" width="25.673"
                                height="25.673" viewBox="0 0 25.673 25.673">
                                <g id="Group_5234" data-name="Group 5234" transform="translate(-348 -189)">
                                    <path id="Path_5432" data-name="Path 5432"
                                        d="M12.836,0A12.836,12.836,0,1,0,25.673,12.836,12.851,12.851,0,0,0,12.836,0Zm0,0"
                                        transform="translate(348 189)" fill="#1d71d3" />
                                    <g id="camera" transform="translate(353.41 195.492)">
                                        <g id="Group_5233" data-name="Group 5233" transform="translate(0)">
                                            <g id="Group_5232" data-name="Group 5232" transform="translate(0 0)">
                                                <path id="Path_5478" data-name="Path 5478"
                                                    d="M15.19,46.727a1.689,1.689,0,0,0-1.24-.523H11.471v-.03a1.341,1.341,0,0,0-.4-.971,1.367,1.367,0,0,0-.971-.4H5.616a1.377,1.377,0,0,0-1.389,1.374v.03H1.762a1.689,1.689,0,0,0-1.24.523A1.776,1.776,0,0,0,0,47.966V55.4a1.689,1.689,0,0,0,.523,1.24,1.776,1.776,0,0,0,1.24.523H13.95a1.689,1.689,0,0,0,1.24-.523,1.776,1.776,0,0,0,.523-1.24V47.966A1.689,1.689,0,0,0,15.19,46.727ZM14.936,55.4h-.015a.969.969,0,0,1-.971.971H1.762A.969.969,0,0,1,.792,55.4V47.966A.969.969,0,0,1,1.762,47H4.645a.4.4,0,0,0,.4-.4v-.433a.562.562,0,0,1,.582-.582H10.1a.562.562,0,0,1,.582.582v.433a.4.4,0,0,0,.4.4h2.883a.969.969,0,0,1,.971.971Z"
                                                    transform="translate(0 -44.8)" fill="#fff" />
                                                <path id="Path_5479" data-name="Path 5479"
                                                    d="M115.674,130.8a3.672,3.672,0,1,0,2.6,1.075A3.681,3.681,0,0,0,115.674,130.8Zm2.031,5.72a2.885,2.885,0,0,1-4.062,0,2.855,2.855,0,0,1-.836-2.031,2.919,2.919,0,0,1,.836-2.031,2.855,2.855,0,0,1,2.031-.836,2.919,2.919,0,0,1,2.031.836,2.855,2.855,0,0,1,.836,2.031A2.8,2.8,0,0,1,117.705,136.52Z"
                                                    transform="translate(-107.818 -127.589)" fill="#fff" />
                                                <circle id="Ellipse_655" data-name="Ellipse 655" cx="0.732" cy="0.732"
                                                    r="0.732" transform="translate(12.441 3.196)" fill="#fff" />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                        <input #fileUploadInput (change)="onFileSelected($event.target.files)" type="file"
                            style="display: none;">
                    </div>
                    <div class="info-section">
                        <div class="row">
                            <div class="col-lg">
                                <mat-form-field appearance="outline" dir="ltr">
                                    <mat-label>{{'user-management.students.student-name' | translate}}</mat-label>
                                    <input matInput formControlName="name"  #studentName
                                        id="studentName">
                                    <mat-error>{{'user-management.error-msgs.student-name-required' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg">
                                <mat-form-field appearance="outline" dir="ltr">
                                    <mat-label>{{'user-management.students.grade' | translate}}</mat-label>
                                    <mat-select (selectionChange)="onGradeChange()" formControlName="grade_id"
                                        >
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="gradeSearch.filterCtrl"
                                                [placeholderLabel]="gradeSearch.placeholderKey | translate"
                                                [noEntriesFoundLabel]="gradeSearch.noResultsKey | translate">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option [value]="grade.id" *ngFor="let grade of gradeSearch.filtered$ | async">
                                            {{grade.name}}</mat-option>
                                    </mat-select>
                                    <mat-error>{{'user-management.error-msgs.grade-required' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg">
                                <mat-form-field appearance="outline" dir="ltr">
                                    <mat-label>{{'user-management.students.class' | translate}}</mat-label>
                                    <mat-select formControlName="class_id">
                                        <mat-option>
                                            <ngx-mat-select-search [formControl]="classSearch.filterCtrl"
                                                [placeholderLabel]="classSearch.placeholderKey | translate"
                                                [noEntriesFoundLabel]="classSearch.noResultsKey | translate">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option [value]="class.id" *ngFor="let class of classSearch.filtered$ | async">
                                            {{class.name}}</mat-option>
                                    </mat-select>
                                    <mat-error>{{'user-management.error-msgs.class-required' | translate}}
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg">
                                <span class="desc">
                                    {{'user-management.edit-requests.edit-modal.footer.desc'| translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <div class="actions-wrapper">
                    <button class="btn btn-primary mb-2" (click)="approveEdit()"  [disabled]="editRequestForm.invalid">
                        {{'user-management.edit-requests.edit-modal.footer.approve'| translate}}
                    </button>
                    <button class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                        {{'user-management.edit-requests.edit-modal.footer.cancel'| translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-error-msg></app-error-msg>